import React, { useEffect, useState } from "react";
import {
  Layout,
  Card,
  Table,
  Space,
  Button,
  Spin,
  DatePicker,
  Input,
  Divider,
} from "antd";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { PlusOutlined } from "@ant-design/icons";

import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";

import { getAPI, displayMessage } from "../../utils/common";
import { ERROR_MSG_TYPE } from "../../constants/messages";
import {
  KITCHEN_PURCHASE_RETURN_LIST,
  KITCHEN_PURCHASE_RETURN_PDF,
} from "../../constants/api";

function KitchenPurchaseReturnList() {
  const { Content } = Layout;
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const [filters, setFilters] = useState({
    from_date: null,
    to_date: null,
    supplier_name: null,
    item_id: null,
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    setLoading(true);

    const params = {
      from_date: filters.from_date
        ? filters.from_date.format("YYYY-MM-DD")
        : null,
      to_date: filters.to_date ? filters.to_date.format("YYYY-MM-DD") : null,
      supplier_name: filters.supplier_name,
      item_id: filters.item_id,
    };

    getAPI(
      KITCHEN_PURCHASE_RETURN_LIST,
      (res) => {
        setData(res.data || []);
        setLoading(false);
      },
      () => setLoading(false),
      params,
    );
  };

  const columns = [
    {
      title: "S.No",
      render: (_, __, index) => index + 1,
      width: 60,
    },
    {
      title: "Return ID",
      dataIndex: "id",
      render: (v) => `#${v}`,
    },
    {
      title: "Purchase ID",
      dataIndex: ["purchase", "id"],
      render: (v) => `#${v}`,
    },
    {
      title: "Return Date",
      dataIndex: "return_date",
      render: (v) => dayjs(v).format("DD MMM YYYY"),
    },
    {
      title: "Return By",
      dataIndex: "return_by",
    },
    {
      title: "Total Amount",
      dataIndex: "total_amount",
      render: (v) => `₹ ${v}`,
    },
    {
      title: "Action",
      render: (_, record) => (
        <Button
          type="primary"
          onClick={() => navigate(`/kitchen/purchase-return/view/${record.id}`)}
        >
          View
        </Button>
      ),
    },
  ];

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Card
          title="Store Purchase Return"
          extra={
            <Space>
              <Button
                type="primary"
                onClick={() => navigate("/kitchen/purchase-return/add")}
              >
                PO Return <PlusOutlined />
              </Button>
            </Space>
          }
        >
          <div>
            <Space wrap>
              {/* Date Range */}
              <DatePicker
                placeholder="From Date"
                onChange={(v) => setFilters({ ...filters, from_date: v })}
              />

              <DatePicker
                placeholder="To Date"
                onChange={(v) => setFilters({ ...filters, to_date: v })}
              />

              {/* Supplier */}
              <Input
                placeholder="Supplier"
                onChange={(e) =>
                  setFilters({ ...filters, supplier_name: e.target.value })
                }
              />

              {/* Item */}
              <Input
                placeholder="Item Code"
                onChange={(e) =>
                  setFilters({ ...filters, item_id: e.target.value })
                }
              />

              {/* Filter Button */}
              <Button type="primary" onClick={fetchData}>
                Filter
              </Button>

              {/* Export PDF */}
              <Button
                danger
                onClick={() =>
                  window.open(
                    `${KITCHEN_PURCHASE_RETURN_PDF}?${new URLSearchParams({
                      from_date: filters.from_date || "",
                      to_date: filters.to_date || "",
                      supplier_name: filters.supplier_name || "",
                      item_id: filters.item_id || "",
                    })}`,
                  )
                }
              >
                Export PDF
              </Button>
            </Space>
          </div>
          <Divider />
          <Spin spinning={loading}>
            <Table columns={columns} dataSource={data} rowKey="id" />
          </Spin>
        </Card>
      </Content>
      <LayoutFooter />
    </Layout>
  );
}

export default KitchenPurchaseReturnList;
